import { ThemeService } from '../services/theme/theme.service';

export function THEME_INITIALIZER(themeService: ThemeService) {
  return () => {
    themeService.ensureDefaultTheme();
  };
}
